"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6250],{

/***/ 96250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var ProjectDescription = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-white border border-gray-700 flex flex-col p-4 gap-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "border-b border-gray-300 text-lg font-normal ",
                children: "Project Description"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-sm text-justify",
                children: props.desc
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                onClick: function() {
                    window.scrollTo(0, 0);
                },
                className: "px-3 py-2 bg-primary w-fit text-white capitalize",
                children: [
                    "Register to get pricing for ",
                    props.title
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ProjectDescription);


/***/ })

}]);